module.exports = __webpack_public_path__ + "static/media/marketing_campaign.144750e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/marketing_campaign.png
// module id = 515
// module chunks = 0